export default __webpack_public_path__ + "static/media/stagger4.37e1177c.png";